import VerifySmsCodePage from "./verifySmsCode";

export default VerifySmsCodePage;